<template>
    <rkm-overlay>
        <rkm-layout-body title="FECHAMENTO DE FAA EM MASSA">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Modal.open()"
                    color="primary"
                >
                    Finalizar FAA
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List ref="List" />
            </rkm-layout-content>

            <Modal
                @save="$refs.List.refresh()"
                ref="Modal"
            />
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/fechamento-faa-massa/List'
import Modal from '@/components/pronto-atendimento/fechamento-faa-massa/Modal'

export default {
    components: {
        List,
        Modal,
    },
}
</script>